import React, { useEffect, useState, useMemo } from "react";
import { Modal, Row, Col, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { UpdateConstructionOrderApi } from "./ConstructionOrderAction";
import { getCategoryData } from "../../AddDetails/categories/Catagory.action";
import { getCustomerData } from "../../AddDetails/AddCustomer/Customer.action";
import { showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import moment from "moment";


const UpdateConstructionOrderModal = (props) => {
    const { t } = useTranslation();
    const [categories, setCategories] = useState([]);
    const [customerId, setCustomerId] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
    const [deliveryDate, setDeliveryDate] = useState(moment().format("YYYY-MM-DD"));
    const [sellingPrice, setSellingPrice] = useState(0);
    const [orderId, setOrderId] = useState("");
    const [comment, setComment] = useState("");

    useEffect(() => {
        if (props.orderData) {
            setOrderId(props.orderData._id);
            setDate(moment(props.orderData.date).format("YYYY-MM-DD"));
            setDeliveryDate(moment(props.orderData.deliveryDate).format("YYYY-MM-DD"));
            setSellingPrice(props.orderData.sellingPrice);
            setCustomerId(props.orderData.customerDetails.customerId);
            setCustomerName(props.orderData.customerDetails.name);
            setCategories(props.orderData.categories || []);
            setComment(props.orderData.comment)
        }
    }, [props.orderData, props.show]);

    // Fetch data on mount
    useEffect(() => {
        props.getCategoryData();
        props.getCustomerData();
    }, []);

    const handleUpdateOrder = () => {
        const payload = {
            date,
            deliveryDate,
            categories,
            sellingPrice,
            comment,
            customerDetails: {
                customerId: customerId,
                name: customerName,
            },
        };
        props.UpdateConstructionOrderApi(
            orderId,
            payload,
            () => {
                showSuccessAlert("Order updated successfully!");
                props.onHide();
                props.onUpdate?.(); // Refresh parent table
            },
            showErrorAlert
        );
    };

    const handleCategoryChange = (selected) => {
        const formatted = selected ? selected.map((item) => ({
            _id: item.value,
            name: item.label,
        })) : [];
        setCategories(formatted);
    };

    const categoryOptions = useMemo(() => {
        return props.categoryList?.data?.map((item) => ({
            value: item._id,
            label: item.name,
        })) || [];
    }, [props.categoryList]);

    const selectedOptions = useMemo(() => {
        return categoryOptions.filter((opt) => categories.some((c) => c._id === opt.value));
    }, [categories, categoryOptions]);

    const customerOptions = useMemo(() => {
        return props.customerDataList?.map((item) => ({
            value: item._id,
            label: item.name,
        })) || [];
    }, [props.customerDataList]);

    const handleCustomerChange = (selected) => {
        setCustomerId(selected.value);
        setCustomerName(selected.label);
    };

    const selectedCustomer = useMemo(() => {
        return customerOptions.find((opt) => opt.value === customerId) || null;
    }, [customerId, customerOptions]);

    return (
        <Modal show={props.show} onHide={props.onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Update Construction Order</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label><b>{t("Date")} *</b></Form.Label>
                            <Form.Control
                                type="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label><b>{t("SelectCategories")} *</b></Form.Label>
                            <Select
                                placeholder="Select Categories"
                                options={categoryOptions}
                                isMulti
                                value={selectedOptions}
                                onChange={handleCategoryChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label><b>{t("SelectCustomer")} *</b></Form.Label>
                            <Select
                                placeholder="Select Customer"
                                options={customerOptions}
                                value={selectedCustomer}
                                onChange={handleCustomerChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label><b>{t("DeliveryDate")} *</b></Form.Label>
                            <Form.Control
                                type="date"
                                value={deliveryDate}
                                onChange={(e) => setDeliveryDate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label><b>{t("SellingPrice")} *</b></Form.Label>
                            <Form.Control
                                placeholder="Selling Price"
                                type="number"
                                value={sellingPrice}
                                min={0}
                                onChange={(e) => setSellingPrice(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label><b>{t("Comment")}</b></Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Comment"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>
                    Close
                </Button>
                <Button
                    variant="contained"
                    endIcon={<SendIcon />}
                    disabled={!date || !categories.length || !customerId || !deliveryDate || !sellingPrice}
                    onClick={handleUpdateOrder}
                    loading={props.isUpdatingOrder}
                >
                    UPDATE
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

const mapDispatchToProps = (dispatch) => ({
    UpdateConstructionOrderApi: (orderId, data, onSuccess, onError) => dispatch(UpdateConstructionOrderApi(orderId, data, onSuccess, onError)),
    getCategoryData: () => dispatch(getCategoryData()),
    getCustomerData: () => dispatch(getCustomerData()),
});

const mapStateToProps = (state) => ({
    isUpdatingOrder: state.ConstructionOrderReducer.isUpdatingOrder,
    isFetchingcategoryList: state.CategoryReducer.isFetchingcategoryList,
    categoryList: state.CategoryReducer.categoryList,
    isFetchingCustomer: state.CustomerReducer.isFetchingCustomer,
    customerDataList: state.CustomerReducer.customerDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateConstructionOrderModal);